import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalTitle from "react-bootstrap/ModalTitle";
import ModalBody from "react-bootstrap/ModalBody";
import ModalFooter from "react-bootstrap/ModalFooter";
import API from "../../../src/apiService";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import Table from "view/component/Table1";
import "view/component/css/costumModal.css";
const SignupSchema = Yup.object().shape({
  uang: Yup.number().required("Nama harus diisi"),
  // username: Yup.string().required("Nama pengguna harus diisi"),
  // password: Yup.string().required("Password tidak boleh kosong"),
  // confirmedPassword: Yup.string()
  //   .required("Password is required")
  //   .oneOf([Yup.ref("password"), null], "Passwords must match")
});
const ModalPedegre = (props) => {
  const [ListData, setListData] = useState([]);
  const getByNoRM = async () => {
    const res = await API.get("/");
    if (res?.code === 200) {
      setListData(res.data);
    }
  };
  return (
    <Modal {...props} aria-labelledby="modal-edit" dialogClassName="modal-90w">
      <ModalHeader closeButton>
        <ModalTitle>
          <h3>Daftar Keluarga</h3>
        </ModalTitle>
      </ModalHeader>
      <Formik
        enableReinitialize
        // initialValues={{
        //   uang: this.state.payments,
        //   total: this.state.total,
        //   charge: this.state.charge,
        // }}
        validationSchema={SignupSchema}
        onSubmit={(values) => {
          console.log(values);
        }}
      >
        {({ values, errors, touched }) => (
          <Form>
            <ModalBody>
              <div>
                <Table
                  headers={[
                    "NO",
                    "Nama",
                    "Hubungan Keluarga",
                    "Tgl Lahir",
                    "Penyakit Kronis",
                    "Alamat",
                  ]}
                  columnMapper={(datas, key) => []}
                  data={[]}
                  // url={"pcare/log"}
                  // bodyRequest={param}
                  // callback={this.changePage}
                />
              </div>
            </ModalBody>
            <ModalFooter></ModalFooter>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};
export default ModalPedegre;
